import { Collapse, ListItem, ListItemText, makeStyles } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import React from "react";
import YouTube from "@u-wave/react-youtube";


const useStyles = makeStyles((theme) => ({
    video: {
        width: '75%',
        margin: 'auto',
    },
}))


export const TutorialListItem = ({ open, label, url, onClick }) => {

    const styles = useStyles();

    return (
        <>
            <ListItem button onClick={onClick}>
                {open ? <ExpandLess /> : <ExpandMore />}
                <ListItemText primary={label} />
            </ListItem>
            <Collapse className={styles.video} in={open} timeout="auto" unmountOnExit>
                <YouTube suggestedQuality="hd720" video={url} modestBranding={true} showCaptions={false} showRelatedVideos={false} annotations={false} autoplay={false} width={'640px'} height={'320px'} />
            </Collapse>
        </>
    );
}